<script>
  import { ArrowDown, ArrowUp } from "lucide-svelte";
  import { Render } from "svelte-headless-table";

  export let cell;
</script>

{#if cell.row.cellForId["marginAmount"].value < 0}
  <div
    class="flex flex-row  justify-between border p-1 rounded-full  border-red-500 text-red-500 text-xs w-[86px]"
  >
    <ArrowDown class={"h-3 w-3"} />
    <!-- <div>
        <Render
            of={cell.row.cellForId["marginPercent"].render()}
        />
        </div> -->
    <div class="px-1">
        <Render of={cell.row.cellForId["marginAmount"].render()} />
    </div>
  </div>
{:else if cell.row.cellForId["marginAmount"].value > 0}
  <div
    class="flex flex-row  justify-between border p-1 rounded-full  border-green-500 text-green-500 text-xs  w-[86px]"
  >
    <ArrowUp class={"h-3 w-3"} />
    <!-- <div>
        <Render
        of={cell.row.cellForId["marginPercent"].render()}
        />
    </div> -->
    <div class="px-1">
        <Render of={cell.row.cellForId["marginAmount"].render()} />
    </div>
  </div>
{:else}
  <Render of={cell.row.cellForId["marginAmount"].render()} />
{/if}
